import type { PlaneFinderStage } from '../../core/types';

/** Minimal stage holder with change notification. Transition policy lives in the
 *  app; this just guards against redundant emits. */
export class PlaneFinderStageMachine {
  private current: PlaneFinderStage = 'empty';

  constructor(private onChange: (stage: PlaneFinderStage) => void) {}

  get stage(): PlaneFinderStage {
    return this.current;
  }

  is(...stages: PlaneFinderStage[]): boolean {
    return stages.includes(this.current);
  }

  set(stage: PlaneFinderStage): void {
    if (stage === this.current) return;
    this.current = stage;
    this.onChange(stage);
  }
}
